const sanitizeInput = (value) => {
  if (!value) return value;

  const trimmed = value.trim();
  const stripped = trimmed.replace(/<[^>]*>?/gm, ""); // remove HTML tags
  return stripped;
};

module.exports = {
  sanitizeInput,
};
